import React from 'react';
import AvailableComponentLists from '../../utils/AvailableComponentLists';
import { selectedToggleValue } from '../../redux/canvasResolutionSlice';
import { useSelector } from 'react-redux';
import { selectedPage } from '../../redux/selectedPageSlice';
import { allPages } from '../../redux/pagesSlice';
import SelectableCssVariablesImport from './SelectableCssVariables/SelectableCssVariablesImport';
import { findCompByIdRecursively } from '../../utils/functions';
import { specialComponents } from '../../utils/functions';
import ErrorBoundary from './Error/ErrorBoundary';

const VtexStoreComponent = ({ componentName, props, children, blocks, wrapper, componentId }) => {
	const selectedCanvasResolution = useSelector(selectedToggleValue);
	if (!componentName) {
		return console.error(`Componente nao encontrado`);
	} else {
		return AvailableComponentLists(
			componentName,
			props,
			children,
			blocks,
			selectedCanvasResolution,
			wrapper,
			componentId,
		);
	}
};

const VtexVisualizationComponentWM = ({ comp, componentId, componentGroup, dontAddHover = false }) => {
	const pageId = useSelector(selectedPage);
	const pages = useSelector(allPages);
	const [compProps, setCompProps] = React.useState(comp);

	React.useEffect(() => {
		const spc = specialComponents[componentGroup];
		if (spc && pageId !== spc) {
			const page = pages.find((page) => page.pageId == spc);
			if (page) {
				const { comp } = findCompByIdRecursively(page.pageData, componentId);
				if (comp) {
					setCompProps(comp);
				} else {
					const foundCompByName = page.pageData.find((comp) => componentGroup == comp.componentGroup);
					if (foundCompByName) {
						setCompProps(foundCompByName);
					} else {
						setCompProps(page.pageData[0]);
					}
				}
			}
		} else if (comp) {
			if (JSON.stringify(compProps) != JSON.stringify(comp)) {
				setCompProps(comp);
			}
		}
	}, [comp, componentId]);

	if (
		!compProps ||
		!compProps.componentName ||
		(compProps.componentName == 'VisibilityLayout' && !compProps.props.visible)
	) {
		return null;
	}

	return (
		<ErrorBoundary>
			{compProps?.variables && <SelectableCssVariablesImport component={compProps} variables={compProps.variables} />}
			{/* {!dontAddHover && !compProps?.props?.mzDontAddHover?<div data-hover={componentId} data-componentname={compProps?.componentName ?? "No Name"} style={{display:"none"}}></div>:null} */}
			<VtexStoreComponent
				{...compProps}
				blocks={
					compProps.blocks &&
					compProps.blocks.map((block) => (
						<VtexVisualizationComponent
							key={'VVC-' + block.componentId}
							{...{
								componentId: block.componentId,
								comp: block,
								componentGroup: block?.componentGroup || componentGroup,
								dontAddHover: compProps?.props?.mzDontAddHover || dontAddHover,
							}}
						/>
					))
				}
			>
				{((compProps && compProps.childrenComponents) || []).map((childComp) => {
					return (
						<VtexVisualizationComponent
							key={`vtex-visualization-component-${childComp.componentId}`}
							{...{
								componentId: childComp.componentId,
								comp: childComp,
								componentGroup: childComp?.componentGroup || componentGroup,
								dontAddHover: compProps?.props?.mzDontAddHover || dontAddHover,
							}}
						/>
					);
				})}
			</VtexStoreComponent>
		</ErrorBoundary>
	);
};
const VtexVisualizationComponent = React.memo(VtexVisualizationComponentWM);
export default VtexVisualizationComponent;
